import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { BannerInterface, setEditId, setEditError, selectBannerById } from "../../../store/mine_craft/bannersSlice";
import { updateBanner, fetchBanner } from "../../../actions/mine_craft/bannersActions";
import { objToFormData } from "../../../helpers/FormHelper";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const Edit = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const id: any = useAppSelector(state => state.mineCraft.banners.editId);
  const error = useAppSelector(state => state.mineCraft.banners.editError);
  const banner = useAppSelector(state => id ? selectBannerById(state, id) : undefined);
  const params: any = { ...banner };

  useEffect(() => {
    if (id) {
      dispatch(fetchBanner(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    dispatch(setEditId(null));
  }, [location, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(rawData: any) {
    const data = { ...rawData };

    handleSave(data).catch(console.error);
  }

  async function handleSave(data: BannerInterface) {
    const formData: any = objToFormData(data);
    const resultAction = await dispatch(updateBanner({ id, data: formData }));

    if (updateBanner.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-banner'>
        <h6 className="v-content-label">Edit Banner</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={params} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
